import Icon from './Icon.wrapper';
import { IIconProps, IconNames, IconSizes } from './Icon.interfaces';

export default Icon;
export {
  Icon, IIconProps, IconNames, IconSizes,
};
